/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ConvertAdvisoryToEstimationRequest,
  ConvertAdvisoryToEstimationResponse,
  CreateConversationFolderRequest,
  CreateConversationFolderResponse,
  CreateConversationRequest,
  CreateConversationResponse,
  ExportConversationRequest,
  ExportConversationResponse,
  GetChatHistoryResponse,
  GetConversationFoldersResponse,
  GetConversationsResponse,
  MoveConversationToFolderRequest,
  RenameConversationFolderRequest,
  RenameConversationRequest,
  SendMessageRequest,
  SendMessageResponse,
  ShareConversationRequest,
  V1AiAdvisoryChatHistoryListError,
  V1AiAdvisoryConversationsConvertToEstimationCreateError,
  V1AiAdvisoryConversationsCreateError,
  V1AiAdvisoryConversationsDeleteError,
  V1AiAdvisoryConversationsExportCreateError,
  V1AiAdvisoryConversationsFolderPartialUpdateError,
  V1AiAdvisoryConversationsListError,
  V1AiAdvisoryConversationsMessagesCreateError,
  V1AiAdvisoryConversationsMessagesStreamCreateError,
  V1AiAdvisoryConversationsPartialUpdateError,
  V1AiAdvisoryConversationsShareCreateError,
  V1AiAdvisoryFoldersCreateError,
  V1AiAdvisoryFoldersDeleteError,
  V1AiAdvisoryFoldersListError,
  V1AiAdvisoryFoldersPartialUpdateError,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class AiAdvisory<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsCreate
   * @summary Creates a new AI advisory conversation
   * @request POST:/api/v1/ai-advisory/conversations
   * @secure
   * @response `201` `CreateConversationResponse` Created
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsCreate = (data: CreateConversationRequest, params: RequestParams = {}) =>
    this.http.request<CreateConversationResponse, V1AiAdvisoryConversationsCreateError>({
      path: `/api/v1/ai-advisory/conversations`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsList
   * @summary Gets paginated list of conversations for the authenticated user
   * @request GET:/api/v1/ai-advisory/conversations
   * @secure
   * @response `200` `GetConversationsResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsList = (
    query?: {
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      Page?: number;
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      PageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GetConversationsResponse, V1AiAdvisoryConversationsListError>({
      path: `/api/v1/ai-advisory/conversations`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsMessagesStreamCreate
   * @summary Sends a message to an AI advisory conversation with streaming response
   * @request POST:/api/v1/ai-advisory/conversations/{id}/messages/stream
   * @secure
   * @response `200` `void` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsMessagesStreamCreate = (
    id: string,
    data: SendMessageRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1AiAdvisoryConversationsMessagesStreamCreateError>({
      path: `/api/v1/ai-advisory/conversations/${id}/messages/stream`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsMessagesCreate
   * @summary Sends a message to an AI advisory conversation (non-streaming, for backwards compatibility)
   * @request POST:/api/v1/ai-advisory/conversations/{id}/messages
   * @secure
   * @response `200` `SendMessageResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsMessagesCreate = (
    id: string,
    data: SendMessageRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<SendMessageResponse, V1AiAdvisoryConversationsMessagesCreateError>({
      path: `/api/v1/ai-advisory/conversations/${id}/messages`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryChatHistoryList
   * @summary Gets paginated chat history for the authenticated user
   * @request GET:/api/v1/ai-advisory/chat-history
   * @secure
   * @response `200` `GetChatHistoryResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryChatHistoryList = (
    query?: {
      /**
       * @format int32
       * @min 1
       * @max 2147483647
       */
      Page?: number;
      /**
       * @format int32
       * @min 1
       * @max 100
       */
      PageSize?: number;
      /**
       * Optional conversation ID to filter messages by specific conversation.
       * If provided, only messages from this conversation will be returned.
       * @format uuid
       */
      ConversationId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.http.request<GetChatHistoryResponse, V1AiAdvisoryChatHistoryListError>({
      path: `/api/v1/ai-advisory/chat-history`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsExportCreate
   * @summary Exports a conversation in the specified format
   * @request POST:/api/v1/ai-advisory/conversations/{id}/export
   * @secure
   * @response `200` `ExportConversationResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsExportCreate = (
    id: string,
    data: ExportConversationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ExportConversationResponse, V1AiAdvisoryConversationsExportCreateError>({
      path: `/api/v1/ai-advisory/conversations/${id}/export`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsConvertToEstimationCreate
   * @summary EWM-605 — converts the latest assistant message in an AI Advisory conversation into a new Estimation draft (Stage = InCreation). The selection step on the frontend determines which WBS items and assumptions are imported; everything else (resourcing, costs, risks) is dropped per v1 scope.
   * @request POST:/api/v1/ai-advisory/conversations/{id}/convert-to-estimation
   * @secure
   * @response `200` `ConvertAdvisoryToEstimationResponse` OK
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsConvertToEstimationCreate = (
    id: string,
    data: ConvertAdvisoryToEstimationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<
      ConvertAdvisoryToEstimationResponse,
      V1AiAdvisoryConversationsConvertToEstimationCreateError
    >({
      path: `/api/v1/ai-advisory/conversations/${id}/convert-to-estimation`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsShareCreate
   * @summary Shares an AI advisory conversation with another user in the same tenant
   * @request POST:/api/v1/ai-advisory/conversations/{id}/share
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsShareCreate = (
    id: string,
    data: ShareConversationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1AiAdvisoryConversationsShareCreateError>({
      path: `/api/v1/ai-advisory/conversations/${id}/share`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsPartialUpdate
   * @summary Renames an AI advisory conversation. Only the conversation owner is allowed to rename.
   * @request PATCH:/api/v1/ai-advisory/conversations/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsPartialUpdate = (
    id: string,
    data: RenameConversationRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1AiAdvisoryConversationsPartialUpdateError>({
      path: `/api/v1/ai-advisory/conversations/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsDelete
   * @summary Deletes an AI advisory conversation
   * @request DELETE:/api/v1/ai-advisory/conversations/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsDelete = (id: string, params: RequestParams = {}) =>
    this.http.request<void, V1AiAdvisoryConversationsDeleteError>({
      path: `/api/v1/ai-advisory/conversations/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryFoldersList
   * @summary Lists the authenticated user's AI advisory conversation folders, alphabetically ordered. Each entry includes the count of contained active conversations.
   * @request GET:/api/v1/ai-advisory/folders
   * @secure
   * @response `200` `GetConversationFoldersResponse` OK
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryFoldersList = (params: RequestParams = {}) =>
    this.http.request<GetConversationFoldersResponse, V1AiAdvisoryFoldersListError>({
      path: `/api/v1/ai-advisory/folders`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryFoldersCreate
   * @summary Creates a new conversation folder for the authenticated user.
   * @request POST:/api/v1/ai-advisory/folders
   * @secure
   * @response `201` `CreateConversationFolderResponse` Created
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryFoldersCreate = (data: CreateConversationFolderRequest, params: RequestParams = {}) =>
    this.http.request<CreateConversationFolderResponse, V1AiAdvisoryFoldersCreateError>({
      path: `/api/v1/ai-advisory/folders`,
      method: 'POST',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryFoldersPartialUpdate
   * @summary Renames a conversation folder. Only the folder owner is allowed to rename.
   * @request PATCH:/api/v1/ai-advisory/folders/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryFoldersPartialUpdate = (
    id: string,
    data: RenameConversationFolderRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1AiAdvisoryFoldersPartialUpdateError>({
      path: `/api/v1/ai-advisory/folders/${id}`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryFoldersDelete
   * @summary Deletes a folder. Contained conversations are re-homed to the unfoldered list and never deleted.
   * @request DELETE:/api/v1/ai-advisory/folders/{id}
   * @secure
   * @response `204` `void` No Content
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryFoldersDelete = (id: string, params: RequestParams = {}) =>
    this.http.request<void, V1AiAdvisoryFoldersDeleteError>({
      path: `/api/v1/ai-advisory/folders/${id}`,
      method: 'DELETE',
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags AiAdvisory
   * @name V1AiAdvisoryConversationsFolderPartialUpdate
   * @summary Assigns a conversation to a folder, or removes it from any folder when `folderId` is null in the body.
   * @request PATCH:/api/v1/ai-advisory/conversations/{id}/folder
   * @secure
   * @response `204` `void` No Content
   * @response `400` `ProblemDetails` Bad Request
   * @response `401` `ProblemDetails` Unauthorized
   * @response `403` `ProblemDetails` Forbidden
   * @response `404` `ProblemDetails` Not Found
   * @response `500` `ProblemDetailsWithErrorCode` Internal Server Error
   */
  v1AiAdvisoryConversationsFolderPartialUpdate = (
    id: string,
    data: MoveConversationToFolderRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, V1AiAdvisoryConversationsFolderPartialUpdateError>({
      path: `/api/v1/ai-advisory/conversations/${id}/folder`,
      method: 'PATCH',
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
